import mixpanel from "mixpanel-browser";

const Analytics = {
  track: ({ name, properties = {} }: { name: string; properties?: Record<string, any> }) => {
    mixpanel.track(name, { ...properties });
  },
  setUserProfiles: ({
    userName,
    userEmail,
    partnerName,
    partnerId,
  }: {
    userName: string;
    userEmail: string;
    partnerName?: string;
    partnerId: string;
  }) => {
    mixpanel?.identify(userEmail.toLowerCase());
    mixpanel?.people.set({
      $name: userName,
      $email: userEmail,
      partnerName,
      partnerId,
    });
  },
  setPartnerName: (partnerName: string) => {
    mixpanel.register({ partnerName });
  },
};

export default Analytics;
